import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../services/api';
import arrayCatcher from '../../../../helpers/errorCatcher';

export const getPropertyGroupsListThunk = createAsyncThunk(
  'propertyGroup/list',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.definitions.propertyGroups.list();
      return response.data.data;
    } catch (err: any) {
      arrayCatcher(err?.code);
      return rejectWithValue(err);
    }
  },
);
